export enum PlayerType {
  MUSIC = 'music',
  ATC = 'atc',
  EFFECTS = 'effects', // For future background effects
}

export enum PlayerState {
  UNSTARTED = 'unstarted',
  BUFFERING = 'buffering',
  PLAYING = 'playing',
  PAUSED = 'paused',
  ENDED = 'ended',
  ERROR = 'error',
  CUED = 'cued',
}

export interface TrackInfo {
  title?: string;
  artist?: string;
  duration?: number;
  currentTime?: number;
  [key: string]: unknown;
}

export interface AudioPlayerEventMap {
  'statechange': (newState: PlayerState) => void;
  'play': () => void;
  'pause': () => void;
  'ended': () => void;
  'error': (error: Error) => void;
  'volumechange': (volume: number) => void;
  'trackchange': (trackInfo: TrackInfo) => void;
  'buffering': (isBuffering: boolean) => void;
}


export interface AudioPlayer {
  readonly id: string; // Unique identifier for the player instance
  readonly type: PlayerType;

  play(): Promise<void>;
  pause(): Promise<void>;
  stop?(): Promise<void>; // Optional: for players that need explicit stop/cleanup

  setVolume(volume: number): Promise<void>; // Volume 0-100
  getVolume(): Promise<number>;

  seekTo?(time: number): Promise<void>; // Optional: in seconds

  loadTrack?(source: string): Promise<void>; // Audio URL source
  nextTrack?(): Promise<void>;
  previousTrack?(): Promise<void>;

  getCurrentTrackInfo?(): Promise<TrackInfo>;
  getPlayerState(): Promise<PlayerState>;
  getDuration?(): Promise<number>; // Return duration in seconds
  getCurrentTime?(): Promise<number>; // Return current time in seconds

  on<K extends keyof AudioPlayerEventMap>(event: K, listener: AudioPlayerEventMap[K]): void;
  off<K extends keyof AudioPlayerEventMap>(event: K, listener: AudioPlayerEventMap[K]): void;

  destroy?(): void; // Cleanup resources
}